import React from 'react';
import { Check, X } from 'lucide-react';

const rules = [
  { test: (p) => p.length >= 8, label: 'Mínimo 8 caracteres' },
  { test: (p) => /[A-Z]/.test(p), label: 'Al menos una letra mayúscula' },
  { test: (p) => /[a-z]/.test(p), label: 'Al menos una letra minúscula' },
  { test: (p) => /[0-9]/.test(p), label: 'Al menos un número' },
  { test: (p) => /[!@#$%^&*()_+\-=[\]{};:'",.<>?/\\|`~]/.test(p), label: 'Al menos un carácter especial (!@#$%...)' },
];

const PasswordStrengthIndicator = ({ password = '' }) => {
  if (!password) return null;

  return (
    <div className="mt-2 space-y-1" data-testid="password-strength-indicator">
      {rules.map((rule, i) => {
        const passed = rule.test(password);
        return (
          <div key={i} className={`flex items-center gap-2 text-xs transition-colors ${passed ? 'text-green-600' : 'text-slate-400'}`}>
            {passed ? <Check className="w-3 h-3 shrink-0" /> : <X className="w-3 h-3 shrink-0" />}
            <span>{rule.label}</span>
          </div>
        );
      })}
    </div>
  );
};

export default PasswordStrengthIndicator;
